import { Injectable } from '@angular/core';

import { Observable, tap } from 'rxjs';
import { CasualHireFormService } from '../../casual-hire-form.service';

@Injectable({
  providedIn: 'root'
})
export class SelectCollectionDateResolver  {
  constructor(private _casualHireFormService: CasualHireFormService) {}

  resolve(): Observable<string[]> {
    // Replace this with the actual method that fetches the data
    // return this._casualHireFormService.getSystemSettings();
    console.log('Fetching available dates...');
    return this._casualHireFormService.getSystemSettings().pipe(
      tap(dates => console.log('Fetched dates:', dates))
    );
  }
}